module.exports = __webpack_public_path__ + "assets/img/pointBoard.65387c86.svg";